import type { ConsultantFormData } from '../types';

export const CONSULTANT_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	surName: 'Sobrenome',
	document: 'CPF/CNPJ',
	phoneNumber: 'Telefone',
	email: 'E-mail',
	status: 'Status',
};

export const DEFAULT_CONSULTANT_FORM: ConsultantFormData = {
	name: '',
	surName: '',
	phoneNumber: '',
	email: '',
	document: '',
	status: '',
};
